import { useEffect, useState } from "react";
import "./style.css";
import breakfastImg from "../../../assets/png/breakfast.png";
import lunchImg from "../../../assets/png/lunch.png";
import snacksImg from "../../../assets/png/snacks.png";
import dinnerImg from "../../../assets/png/dinner.png";
import { FaEdit, FaTrash } from "react-icons/fa";
import AddDishModal from "../modal/add-dish-modal";
import EditDishModal from "../modal/edit-dish-modal";
import ConfirmationModal from "../modal/confirmation-modal";
import AssessmentQuestions from "../assessment-questions";
import moment from "moment";
import { useParams, useNavigate } from "react-router-dom";
import LineGraphModal from "../modal/line-graph-modal";
import { isAccessAllowed } from "../../../utils/helpers";
import makeRequest from "../../../api";
import {
  nutritionApiService,
  nutritionService,
  subscriptionService,
  userService,
} from "../../../api/services";
import { toast } from "react-toastify";

interface mealSchema {
  mealImg: any;
  mealType: any;
  meals: any[];
  date: any;
  mealPlan: any;
  updateMealPlan: any;
  userResponses: any;
  mealTypeLabel: any;
}

const Meal = ({
  mealImg,
  mealType,
  meals,
  date,
  mealPlan,
  updateMealPlan,
  userResponses,
  mealTypeLabel,
}: mealSchema) => {
  const isMealPlanEditAllowed = isAccessAllowed("MEAL_PLAN_EDIT");

  const [showAddDishModal, setShowAddDishModal] = useState(false);
  const [showEditDishModal, setShowEditDishModal] = useState(false);
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] =
    useState(false);
  const [editId, setEditId] = useState(-1);
  const [editDish, setEditDish] = useState({});
  const [totalCalorie, setTotalCalorie] = useState(0);
  const [totalProtein, setTotalProtein] = useState(0);
  const [totalCarbs, setTotalCarbs] = useState(0);
  const [totalFibre, setTotalFibre] = useState(0);

  const handleDelete = () => {
    const newMealPlan = mealPlan.map((item: any) => {
      if (item?.date === date) {
        item?.meals?.forEach((x: any) => {
          if (x.mealType === mealType) {
            x.dishes.splice(editId, 1);
          }
        });
      }
      return item;
    });
    updateMealPlan(newMealPlan);
  };
  useEffect(() => {
    setTotalCarbs(
      meals?.reduce((accumulator, item) => {
        return accumulator + item?.carbs;
      }, 0)
    );
    setTotalFibre(
      meals?.reduce((accumulator, item) => {
        return accumulator + item?.fibre;
      }, 0)
    );
    setTotalCalorie(
      meals?.reduce((accumulator, item) => {
        return accumulator + item?.calorie;
      }, 0)
    );
    setTotalProtein(
      meals?.reduce((accumulator, item) => {
        return accumulator + item?.protein;
      }, 0)
    );
  }, [meals, mealPlan]);

  return (
    <div
      className="meal p-3 mb-3 rounded"
      style={{ backgroundColor: "whitesmoke" }}
    >
      {showAddDishModal && (
        <AddDishModal
          open={showAddDishModal}
          setOpen={setShowAddDishModal}
          date={date}
          mealType={mealType}
          mealPlan={mealPlan}
          updateMealPlan={updateMealPlan}
          userResponses={userResponses}
          mealTypeLabel={mealTypeLabel}
        />
      )}
      {showEditDishModal && (
        <EditDishModal
          open={showEditDishModal}
          setOpen={setShowEditDishModal}
          editId={editId}
          date={date}
          mealType={mealType}
          mealPlan={mealPlan}
          updateMealPlan={updateMealPlan}
          editDish={editDish}
        />
      )}

      {showDeleteConfirmationModal && (
        <ConfirmationModal
          open={showDeleteConfirmationModal}
          setOpen={setShowDeleteConfirmationModal}
          title="Delete Modal"
          description="Are you sure you want to delete the Dish"
          setConfirmation={handleDelete}
        />
      )}
      <div className="row mx-0">
        <div className="col-2 d-flex flex-column align-items-start">
          <h5>Meal type</h5>
          <img src={mealImg} width={"40px"} height={"40px"} alt="" />
          <span className="colored">{mealType}</span>
          {isMealPlanEditAllowed && (
            <button
              className="btn btn-outline-secondary btn-sm mt-2"
              onClick={() => {
                setShowAddDishModal(true);
              }}
            >
              Add Dish
            </button>
          )}
        </div>
        <div className="col-10">
          <div className="row mx-0 header mb-3">
            <div className="col-3">Dish name</div>
            <div className="col-2">Type</div>
            <div className="col-3">Serving</div>
            <div className="col-2">Quantity</div>
            <div className="col-2">Action</div>
          </div>
          <div className="dishes">
            {meals?.length > 0 &&
              meals?.map((item, index) => {
                return (
                  <div
                    key={index}
                    className="row mx-0 dish py-2 mb-2 align-items-center rounded"
                    style={{ backgroundColor: "lightgrey" }}
                  >
                    <div className="col-3" style={{ fontWeight: "bold" }}>
                      {item?.name}
                    </div>
                    <div className="col-2">{item?.type}</div>
                    <div className="col-3">
                      {item?.unitCount}-{item?.displayText}
                    </div>
                    <div className="col-2">
                      {item?.totalQuantity} {item?.servingUnit}
                    </div>
                    <div className="col-2">
                      {isMealPlanEditAllowed && (
                        <>
                          <FaEdit
                            size={16}
                            className="me-3"
                            onClick={() => {
                              setShowEditDishModal(true);
                              setEditId(index);
                              setEditDish(item);
                            }}
                          />
                          <FaTrash
                            size={16}
                            onClick={() => {
                              setShowDeleteConfirmationModal(true);
                              setEditId(index);
                            }}
                          />
                        </>
                      )}
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-end">
        <div className="me-3" style={{ fontWeight: "bold" }}>
          Total Carbs : {totalCarbs?.toFixed(2)} gms
        </div>
        <div className="me-3" style={{ fontWeight: "bold" }}>
          Fibre : {totalFibre?.toFixed(2)} gms
        </div>
        <div className="me-3" style={{ fontWeight: "bold" }}>
          Calories : {totalCalorie?.toFixed(2)} kcal
        </div>
        <div className="me-3" style={{ fontWeight: "bold" }}>
          Protein : {totalProtein?.toFixed(2)} gms
        </div>
      </div>
    </div>
  );
};

interface MacroState {
  [key: number]: number;
}

const MealPlan = () => {
  const params = useParams();
  const userId = params.userId;
  const navigate = useNavigate();

  const isMealPlanEditAllowed = isAccessAllowed("MEAL_PLAN_EDIT");

  const [userDetails, setUserDetails] = useState<any>({});
  const [mealPlan, setMealPlan] = useState<any>([]);

  const [isRegenerated, setIsRegenerated] = useState();
  const [selectedDate, setSelectedDate] = useState<any>(0);
  const [showSaveChangesModal, setShowSaveChangesModal] = useState(false);
  const [currentWeek, setCurrentWeek] = useState(0);
  const [healthGoal, setHealthGoal] = useState("");
  const [issueBasedPlanStatus, setIssueBasedPlanStatus] = useState("");
  const [weeklyTargets, setWeeklyTargets] = useState(Object);
  const [showLineGraphModal, setShowLineGraphModal] = useState(false);
  const [totalFibreAllocationForWeek, setTotalFibreAllocationForWeek] =
    useState(0);

  const [planDuration, setPlanDuration] = useState(0);
  const weeks = Array.from({ length: planDuration }, (_, i) => i + 1);

  const [dayCalorieTotal, setDayCalorieTotal] = useState<MacroState>({});
  const [dayProteinTotal, setDayProteinTotal] = useState<MacroState>({});
  const [dayCarbsTotal, setDayCarbsTotal] = useState<MacroState>({});
  const [dayFibreTotal, setDayFibreTotal] = useState<MacroState>({});
  const [userResponses, setUserResponses] = useState<any>({});
  const [mealplanStartDate, setMealplanStartDate] = useState<string>("");
  const [pdfDownloading, setPDFDownloading] = useState(false);

  const getUserWeeklyTargets = async (goal: string, weeks: number) => {
    const res = await makeRequest(
      nutritionApiService.getUserWeeklyTarget(
        {
          goal,
          weeks,
        },
        userId
      )
    );
    if (res?.data?.status) {
      setWeeklyTargets(res?.data?.data);
    } else {
      toast.error("Error fetching user's weekly targets!");
    }
  };

  const getUserData = async () => {
    try {
      const res = await makeRequest(userService.getUserDetails(userId));
      setUserDetails({ ...res?.data?.userDto });
    } catch (error: any) {
      toast.error("Error fetching user details!");
    }
  };

  useEffect(() => {
    if (userId) {
      getUserData();
    }
  }, [userId]);

  const getStartDate = async () => {
    try {
      const data = await makeRequest(
        nutritionService.getMealPlanStartDate({
          userId,
        })
      );
      setIsRegenerated(data?.data?.isRegenerated);
      if (
        typeof data?.data?.mealPlanStartDate === "undefined" ||
        data?.data?.mealPlanStartDate === ""
      ) {
        let startdate = moment().format("YYYY-MM-DD");
        setMealplanStartDate(startdate);
      } else {
        setMealplanStartDate(data?.data?.mealPlanStartDate);
      }
    } catch (error: any) {
      toast.error("Error fetching meal plan start date!");
    }
  };

  const getCurrentPlanData = async () => {
    try {
      const res = await makeRequest(
        subscriptionService.getUserCurrentActive(userId)
      );

      const plan =
        res?.data?.data?.find((item: any) => item.gabit === "NUTRITION") || {};
      if (plan) {
        const numberOfDays = moment(plan?.endDate)?.diff(
          plan?.startDate,
          "days"
        );
        const numberOfWeeks = Math.ceil(numberOfDays / 7) + 2;

        setPlanDuration(numberOfWeeks);
        setHealthGoal(plan?.healthGoal);
        setIssueBasedPlanStatus(plan?.issueBasedMealPlanStatus);
        getUserWeeklyTargets(plan?.healthGoal, numberOfWeeks);
      }
    } catch (error: any) {
      toast.error("Error fetching user's current active plan!");
    }
  };

  useEffect(() => {
    if (userId) {
      getCurrentPlanData();
      getStartDate();
    }
  }, [userId]);

  const updateTotalFibreForWeek = (mealplan: any) => {
    let totalFibre = 0;

    for (let i = 0; i < mealplan.length; ++i) {
      for (let j = 0; j < mealplan[i]?.meals?.length; ++j) {
        let dishes = mealplan[i]?.meals[j]?.dishes;
        for (let k = 0; k < dishes?.length; ++k) {
          totalFibre += dishes[k]?.fibre;
        }
      }
    }

    setTotalFibreAllocationForWeek(parseFloat(totalFibre?.toFixed(2)));
  };

  const getMealplan = async () => {
    try {
      let mondayOfWeek = moment(mealplanStartDate)
        .startOf("isoWeek")
        .add(currentWeek - 1, "weeks")
        .format("YYYY-MM-DD");

      let params = {
        userId: userId,
        date: mondayOfWeek,
      };
      const res = await makeRequest(
        nutritionService.getUserMealPlan(params, userId)
      );
      setMealPlan(res?.data?.mealPlans);

      updateTotalFibreForWeek(res?.data?.mealPlans);
    } catch (error: any) {
      toast.error("Error fetching user's meal plan !");
    }
  };

  const getMeal = async () => {
    if (userId !== "" && currentWeek > 0) {
      getMealplan();
    }
  };

  useEffect(() => {
    if (mealplanStartDate) {
      getMeal();
      setSelectedDate(0);
    }
  }, [userDetails, currentWeek]);

  useEffect(() => {
    let mealCalorieTotal = 0;
    let mealProteinTotal = 0;
    let mealCarbsTotal = 0;
    let mealFibreTotal = 0;

    if (mealPlan?.length > 0) {
      mealPlan[selectedDate]?.meals?.forEach((item: any) => {
        const x = item?.dishes;

        for (let i = 0; i < x.length; ++i) {
          mealCalorieTotal += x[i].calorie;
          mealProteinTotal += x[i].protein;
          mealCarbsTotal += x[i].carbs;
          mealFibreTotal += x[i].fibre;
        }

        let calorieObj = dayCalorieTotal;
        calorieObj[selectedDate] = mealCalorieTotal;
        setDayCalorieTotal(calorieObj);

        let proteinObj = { ...dayProteinTotal };
        proteinObj[selectedDate] = mealProteinTotal;
        setDayProteinTotal(proteinObj);

        let carbsObj = { ...dayCarbsTotal };
        carbsObj[selectedDate] = mealCarbsTotal;
        setDayCarbsTotal(carbsObj);

        let fibreObj = { ...dayFibreTotal };
        fibreObj[selectedDate] = mealFibreTotal;
        setDayFibreTotal(fibreObj);
      });
    }
  }, [selectedDate, mealPlan]);

  const updateMealPlan = (x: any) => {
    setMealPlan(() => [...x]);
  };

  const missingMeal = (dayNo: number) => {
    let status = false;
    let meals = mealPlan?.[dayNo]?.meals;
    for (let i = 0; i < meals.length; ++i) {
      if (meals[i]?.dishes.length === 0) {
        status = true;
        break;
      }
    }
    return status;
  };

  const showCalorieData = () => {
    let week = "w" + currentWeek;
    let day = "d" + (selectedDate + 1);
    let dayTotals = weeklyTargets?.[week]?.[day]?.total;
    let diff = parseFloat(
      (dayCalorieTotal[selectedDate] - dayTotals?.initialCalorie)?.toFixed(2)
    );

    let calPercent = 100 * (diff / dayTotals?.initialCalorie);

    let str =
      dayCalorieTotal[selectedDate]?.toFixed(2) +
      " / " +
      dayTotals?.initialCalorie +
      " kcal [ " +
      diff +
      "( " +
      calPercent?.toFixed(2) +
      "% ) ]";
    return str;
  };

  const showProteinData = () => {
    let week = "w" + currentWeek;
    let day = "d" + (selectedDate + 1);
    let dayTotals = weeklyTargets?.[week]?.[day]?.total;
    let diff = parseFloat(
      (dayProteinTotal?.[selectedDate] - dayTotals?.protein)?.toFixed(2)
    );
    let proPercent = 100 * (diff / dayTotals?.protein);

    let str =
      dayProteinTotal?.[selectedDate]?.toFixed(2) +
      " / " +
      dayTotals?.protein?.toFixed(2) +
      " gms [ " +
      diff +
      "( " +
      proPercent?.toFixed(2) +
      "% ) ]";

    return str;
  };

  const showCarbsData = () => {
    let week = "w" + currentWeek;
    let day = "d" + (selectedDate + 1);
    let dayTotals = weeklyTargets?.[week]?.[day]?.total;
    let diff = parseFloat(
      (dayCarbsTotal[selectedDate] - dayTotals?.carbs)?.toFixed(2)
    );
    let carbsPercent = 100 * (diff / dayTotals?.carbs);

    let str =
      dayCarbsTotal[selectedDate]?.toFixed(2) +
      " / " +
      dayTotals?.carbs?.toFixed(2) +
      " gms [ " +
      diff +
      "( " +
      carbsPercent?.toFixed(2) +
      "% ) ]";

    return str;
  };

  const showFibreData = () => {
    let week = "w" + currentWeek;
    let day = "d" + (selectedDate + 1);
    let dayTotals = weeklyTargets?.[week]?.[day]?.total;
    let diff = parseFloat(
      (dayFibreTotal[selectedDate] - dayTotals?.fibre)?.toFixed(2)
    );
    let fibrePercent = 100 * (diff / dayTotals?.fibre);

    let str =
      dayFibreTotal[selectedDate]?.toFixed(2) +
      " / " +
      dayTotals?.fibre?.toFixed(2) +
      " gms [ " +
      diff +
      "( " +
      fibrePercent?.toFixed(2) +
      "% ) ]";

    return str;
  };

  const saveChanges = async () => {
    let data: any = mealPlan.map((item: any) => {
      let mealObj = {};
      let preworkoutSlot = null;
      item?.meals?.forEach((meal: any) => {
        if (meal?.preWorkoutSlot !== null) {
          preworkoutSlot = meal?.preWorkoutSlot;
        }
        const mealTypeLabel =
          meal?.mealTimeLabel[0]?.toLowerCase() + meal?.mealTimeLabel?.slice(1);
        let y = meal?.dishes?.map((dish: any) => {
          return {
            id: dish?.id,
            standard_values_in_grams: dish?.standard_values_in_grams ?? 1,
            calorie: dish?.calorie,
            protein: dish.protein,
            fibre: dish?.fibre,
            carbs: dish?.carbs,
            fat: dish?.fat,
            fattyAcidTotalSaturated: dish?.fattyAcidTotalSaturated,
            sodium: dish?.sodium,
            unitName: dish?.unitName,
            unitSize: dish?.unitSize,
            unitCount: dish?.unitCount,
            totalQuantity: dish?.totalQuantity,
            type: dish?.type ?? "",
          };
        });
        mealObj = {
          ...mealObj,
          [mealTypeLabel]: y,
        };
      });

      const x = {
        date: item.date,
        week: item.weekNo,
        preworkoutSlot,
        isFastingDay: item?.isFastingDay,
        ...mealObj,
      };
      return x;
    });

    let params = {
      userId: userId,
      mealPlans: data,
    };

    await (async () => {
      try {
        await makeRequest(nutritionService.saveMealPlanPanel(params));
      } catch (error: any) {
        toast.error("Error saving meal plan!");
      }
      await getMeal();
      return Promise.resolve();
    })();
  };

  const getMealPlanImage = (mealType: string) => {
    switch (mealType) {
      case "Breakfast":
        return breakfastImg;
      case "Lunch":
        return lunchImg;
      case "Snacks":
        return snacksImg;
      case "Dinner":
        return dinnerImg;
      default:
        return breakfastImg;
    }
  };

  const downloadMealPlanPDF = async (currentDate: string) => {
    setPDFDownloading(true);
    try {
      const res = await makeRequest(
        nutritionService.generateMealPlanPDF(
          {
            date: currentDate,
          },
          userId
        )
      );

      if (res?.data) {
        window.open(res?.data?.pdfLink);
      }
    } catch (error: any) {
      toast.error("Error fetching meal plan pdf!");
    }
    setPDFDownloading(false);
  };

  return (
    <div className="meal-planner">
      {showSaveChangesModal && (
        <ConfirmationModal
          open={showSaveChangesModal}
          setOpen={setShowSaveChangesModal}
          title="Save Changes"
          description="Are you sure you want to save the changes?"
          setConfirmation={saveChanges}
        />
      )}
      {showLineGraphModal && (
        <LineGraphModal
          open={showLineGraphModal}
          setOpen={setShowLineGraphModal}
          mealPlan={mealPlan}
        />
      )}

      <div className="container-lg py-4">
        <h3 className="d-flex align-items-center">
          Meal Plan for {userDetails?.fullName}
          {isRegenerated && (
            <span
              className="badge badge-pill badge-info bg-info ms-2 mt-1"
              style={{
                fontSize: "0.75rem",
              }}
            >
              Regenerated
            </span>
          )}
        </h3>
        <div className="d-flex algin-items-center justify-content-start mb-4">
          <button
            className={`btn btn-sm me-3 ${
              currentWeek === 0 ? "btn-secondary" : "btn-outline-secondary"
            } `}
            onClick={() => setCurrentWeek(0)}
          >
            Assessment Question
          </button>

          <div>
            {weeks.map((week) => {
              return (
                <button
                  key={"week-" + week}
                  className={`btn btn-sm me-3 mb-1 ${
                    currentWeek === week
                      ? "btn-secondary"
                      : "btn-outline-secondary"
                  } `}
                  onClick={() => setCurrentWeek(week)}
                  style={{ width: "75px" }}
                >
                  Week{week}
                </button>
              );
            })}
            <button
              className={"btn btn-sm me-3 mb-1 btn-secondary"}
              onClick={() =>
                navigate("/users/" + userId + "/meal-plan/analysis")
              }
              style={{ width: "75px" }}
            >
              Analysis
            </button>
          </div>
        </div>

        {currentWeek === 0 && (
          <AssessmentQuestions
            mealPlanStartDate={mealplanStartDate}
            numberOfWeeks={planDuration}
            userData={userDetails}
            healthGoal={healthGoal}
            setUserResponses={setUserResponses}
            issueBasedPlanStatus={issueBasedPlanStatus}
          />
        )}
        {currentWeek > 0 &&
          (mealPlan.length === 0 ? (
            <div className="row mx-0">
              <div className="col-12">
                <h3>No meal plan available</h3>
              </div>
            </div>
          ) : (
            <div>
              <div className="row mx-0 rounded bg-white">
                <div className="col-2 rounded p-3 pe-0">
                  <div className="sidebar p-3 rounded">
                    {mealPlan?.map((item: any, index: number) => (
                      <div
                        key={`day-${index}`}
                        className={
                          selectedDate === index
                            ? "day p-3 active"
                            : "day p-3 mb-2"
                        }
                        onClick={() => setSelectedDate(index)}
                      >
                        <h6 className="mb-1">Day {index + 1}</h6>
                        {!item?.isFastingDay && missingMeal(index) && (
                          <p className="mb-1" style={{ color: "red" }}>
                            * missing meal
                          </p>
                        )}
                        <p className="mb-0">
                          {moment(item?.date).format("DD MMM YYYY")}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="col-10 p-3">
                  <div className="d-flex justify-content-between">
                    <button
                      className="btn btn-secondary btn-sm mb-3"
                      disabled={pdfDownloading}
                      onClick={() => downloadMealPlanPDF(mealPlan?.[0]?.date)}
                    >
                      Download meal plan for the week
                    </button>

                    <span>
                      {" "}
                      Total fibre given this week :{" "}
                      <b>{totalFibreAllocationForWeek} gms</b>
                    </span>
                  </div>

                  {mealPlan?.[selectedDate]?.isFastingDay && (
                    <h5>
                      <strong>Fasting Day</strong>
                    </h5>
                  )}
                  <div
                    className="d-flex flex-column rounded mb-3 p-3"
                    style={{
                      backgroundColor: "whitesmoke",
                    }}
                  >
                    <div>
                      <span style={{ fontWeight: "bold" }}>
                        Calorie [ Given / Required ] :{" "}
                      </span>
                      <span>
                        {dayCalorieTotal[selectedDate] !== undefined &&
                          showCalorieData()}
                      </span>
                    </div>
                    <div>
                      <span style={{ fontWeight: "bold" }}>
                        Protein [ Given / Required ] :
                      </span>{" "}
                      {dayProteinTotal?.[selectedDate] !== undefined &&
                        showProteinData()}
                    </div>
                    <div>
                      <span style={{ fontWeight: "bold" }}>
                        Carbs &nbsp;[ Given / Required ] :
                      </span>
                      {"   "}
                      {dayCarbsTotal[selectedDate] !== undefined &&
                        showCarbsData()}
                    </div>
                    <div>
                      <span style={{ fontWeight: "bold" }}>
                        Fibre [ Given / Required ] :
                      </span>
                      {"  "}
                      {dayFibreTotal[selectedDate] !== undefined &&
                        showFibreData()}
                    </div>
                  </div>

                  {mealPlan?.[selectedDate]?.meals?.map(
                    (meal: any, index: number) => (
                      <div key={`meal-${index}`}>
                        <Meal
                          mealType={meal?.mealType}
                          mealImg={getMealPlanImage(meal?.mealType)}
                          meals={meal?.dishes}
                          date={mealPlan?.[selectedDate]?.date}
                          mealPlan={mealPlan}
                          updateMealPlan={updateMealPlan}
                          userResponses={userResponses}
                          mealTypeLabel={meal?.mealTimeLabel}
                        />
                      </div>
                    )
                  )}
                </div>
              </div>
              {isMealPlanEditAllowed && (
                <div
                  className="d-flex justify-content-end"
                  style={{
                    marginTop: "5px",
                    marginBottom: "5px",
                  }}
                >
                  <button
                    className="btn btn-secondary mt-3"
                    onClick={() => {
                      setShowSaveChangesModal(true);
                    }}
                  >
                    Save Changes
                  </button>
                </div>
              )}
            </div>
          ))}
      </div>
    </div>
  );
};

export default MealPlan;
